import { StepValidation } from "../trackLeadPayload"

export const preOwnedSteps: StepValidation = {
  preOwned: [
    "firstName",
    "lastName",
    "email",
    "phone",
    "language",
    "enterpriseNumber",
    "enterpriseName",
    "carModel",
    "carModelType",
    "carModelYear",
    "location",
    "newCar",
    "informationNotice",
    "validQuotationDisclaimer",
    "privacyPolicy",
    "zip"
  ]
}
